/* ==========================================================================
   DIDIBOU V3 — SHELL
   Header (état scroll), navigation mobile, tiroir panier (UI).
   La donnée panier vit dans cart.js (store localStorage + events).
   ========================================================================== */
(() => {
  /* ---------- Header : ombre au scroll ---------- */
  const header = document.querySelector('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Helper : piège à focus pour les surfaces modales (nav, panier) ----------
     WCAG 2.4.3 / 2.1.2 : on garde le focus dans le panneau ouvert et on le rend au
     déclencheur à la fermeture. Les rôles dialog/aria-modal sont posés ici (DRY :
     valable sur les 13 pages sans toucher le HTML). */
  const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  const trapTab = (e, panel) => {
    if (e.key !== 'Tab') return;
    const items = [...panel.querySelectorAll(FOCUSABLE)].filter((el) => el.getClientRects().length);
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  };

  /* ---------- Nav mobile ---------- */
  const navMobile = document.querySelector('[data-nav-mobile]');
  const burger = document.querySelector('[data-burger]');
  if (navMobile && burger) {
    navMobile.setAttribute('role', 'dialog');
    navMobile.setAttribute('aria-modal', 'true');
    const close = document.querySelector('[data-nav-close]');
    let navLast = null;
    const onNavKey = (e) => trapTab(e, navMobile);
    const setOpen = (open) => {
      navMobile.classList.toggle('is-open', open);
      burger.setAttribute('aria-expanded', String(open));
      document.body.style.overflow = open ? 'hidden' : '';
      if (open) {
        navLast = document.activeElement;
        navMobile.addEventListener('keydown', onNavKey);
        (close || navMobile.querySelector(FOCUSABLE))?.focus();
      } else {
        navMobile.removeEventListener('keydown', onNavKey);
        navLast?.focus?.();
        navLast = null;
      }
    };
    burger.addEventListener('click', () => setOpen(true));
    close?.addEventListener('click', () => setOpen(false));
    navMobile.querySelectorAll('a').forEach((a) => a.addEventListener('click', () => setOpen(false)));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') setOpen(false); });
  }

  /* ---------- Tiroir panier : ouverture / fermeture ---------- */
  const drawer = document.querySelector('[data-cart-drawer]');
  if (drawer) {
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    let cartLast = null;
    const onCartKey = (e) => trapTab(e, drawer);
    const setCart = (open) => {
      document.documentElement.classList.toggle('is-cart-open', open);
      document.body.style.overflow = open ? 'hidden' : '';
      if (open) {
        cartLast = document.activeElement;
        drawer.addEventListener('keydown', onCartKey);
        drawer.querySelector('[data-cart-close]')?.focus();
      } else {
        drawer.removeEventListener('keydown', onCartKey);
        cartLast?.focus?.();
        cartLast = null;
      }
    };
    document.querySelectorAll('[data-cart-open]').forEach((btn) =>
      btn.addEventListener('click', () => setCart(true))
    );
    document.querySelector('[data-cart-close]')?.addEventListener('click', () => setCart(false));
    document.querySelector('[data-cart-overlay]')?.addEventListener('click', () => setCart(false));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') setCart(false); });
    document.addEventListener('cart:added', () => setCart(true));
  }

  /* ---------- CTA flottant « Composer mon pack » ----------
     Visible seulement dans la zone « on convainc » : après le hero et avant
     d'atteindre l'offre (#packs), où le bouton existe déjà. */
  const floatCta = document.querySelector('[data-float-cta]');
  if (floatCta && 'IntersectionObserver' in window) {
    const hero = document.querySelector('.hero');
    const offer = document.querySelector('#packs');
    let pastHero = false;
    let beforeOffer = true;
    const sync = () => floatCta.classList.toggle('is-visible', pastHero && beforeOffer);

    if (hero) {
      new IntersectionObserver(([e]) => {
        pastHero = !e.isIntersecting && e.boundingClientRect.top < 0;
        sync();
      }, { rootMargin: '-72px 0px 0px 0px' }).observe(hero);
    }
    if (offer) {
      new IntersectionObserver(([e]) => {
        beforeOffer = !e.isIntersecting && e.boundingClientRect.top > 0;
        sync();
      }).observe(offer);
    }
    /* clic = on ferme la nav mobile si ouverte, puis navigation naturelle */
    floatCta.addEventListener('click', () => document.querySelector('[data-nav-mobile]')?.classList.remove('is-open'));
  }
})();
